import React, { useState, useMemo, useEffect } from "react";

export default function UsageInspectorPopUp({hoverData, hoverPos, resolveActivity}){
	
		if (!hoverData) {

	       return null;

	   	}
		
		
			
			const isMeeting =
		        hoverData?.capacity > 1;

		    const TOOLTIP_HEIGHT =
		        260;

		    const TOOLTIP_WIDTH =
		        isMeeting
		            ? 340
		            : 280;

		    let top =
		        hoverPos.y + 12;

		    let left =
		        hoverPos.x + 12;

		    if (
		        top + TOOLTIP_HEIGHT >
		        window.innerHeight
		    ) {

		        top =
		            hoverPos.y -
		            TOOLTIP_HEIGHT -
		            12;

		    }

		    if (
		        left + TOOLTIP_WIDTH >
		        window.innerWidth
		    ) {

		        left =
		            hoverPos.x -
		            TOOLTIP_WIDTH -
		            12;

		    }
			
			
			

		    return (

		        <div
		            style={{
		                position: "fixed",
		                top: top,
		                left: left,
		                background: "#0f172a",
		                color: "#e5e7eb",
		                padding: "12px",
		                borderRadius: "10px",
		                fontSize: "12px",
		                boxShadow:
		                    "0 15px 40px rgba(0,0,0,0.6)",
		                zIndex: 99999,
		                minWidth:
		                    isMeeting
		                        ? "320px"
		                        : "240px",
		                maxWidth:
		                    isMeeting
		                        ? "360px"
		                        : "280px",
		                pointerEvents: "auto"
		            }}
		        >

		            {/* HEADER */}
		            <div
		                style={{
		                    fontWeight: "600",
		                    marginBottom: "8px",
		                    borderBottom:
		                        "1px solid rgba(255,255,255,0.08)",
		                    paddingBottom: "4px"
		                }}
		            >

		                {hoverData.spaceCode &&
		                    hoverData.spaceCode + " • "}

		                {hoverData.date}

		            </div>

					{/* HOURS */}
					{hoverData.hours
					    ?.filter(function (h, index, arr) {

					        // ------------------------------------------------
					        // DEDUPE
					        // ------------------------------------------------
							
							
							

					        const key =
					            h.hour +
					            "_" +
					            (h.activityId || 0) +
					            "_" +
					            (h.bookingStatus || 0);

					        return (
					            index ===
					            arr.findIndex(function (x) {

					                const compareKey =
					                    x.hour +
					                    "_" +
					                    (x.activityId || 0) +
					                    "_" +
					                    (x.bookingStatus || 0);

					                return compareKey === key;

					            })
					        );

					    })
					    .map(function (h) {

					        const resolved =
					            resolveActivity(h);

					        const used =
					            h.capacityUsed ?? 0;

					        const cap =
					            hoverData.capacity ??
					            h.capacity ??
					            0;

					        const pct =
					            cap > 0
					                ? Math.round(
					                    (used / cap) * 100
					                )
					                : 0;

					        // ------------------------------------------------
					        // BOOKING STATUS COLOUR
					        // ------------------------------------------------

					      
							
							let bookingLabel = null;
							let bookingColour = null;

							if (h.bookingStatus === 1) {

							    bookingLabel = "Booked";
							    bookingColour = "#f59e0b";

							}
							else if (h.bookingStatus === 2) {

							    bookingLabel = "No Show";
							    bookingColour = "#ef4444";

							}
							else if (h.bookingStatus === 3) {

							    bookingLabel = "Ghost";
							    bookingColour = "#8b5cf6";

							}

					        return (

					            <div
					                key={
					                    h.hour +
					                    "_" +
					                    (h.activityId || 0) +
					                    "_" +
					                    (h.bookingStatus || 0)
					                }
					                style={{
					                    display: "grid",
										gridTemplateColumns:
										    "70px 100px 90px 90px",
					                    alignItems: "center",
					                    marginBottom: "4px",
					                    padding: "3px 6px",
					                    borderRadius: "4px",
					                    background:
					                        "rgba(255,255,255,0.03)"
					                }}
					            >

					                {/* TIME */}
					                <div
					                    style={{
					                        display: "flex",
					                        alignItems: "center",
					                        gap: "6px"
					                    }}
					                >

					                    {/* UTILISATION DOT */}
					                    <div
					                        style={{
					                            width: "8px",
					                            height: "8px",
					                            borderRadius: "50%",
					                            background:
					                                resolved.background ||
					                                "#475569",
					                            opacity:
					                                resolved.opacity ??
					                                1
					                        }}
					                    />

					                    <span
					                        style={{
					                            fontSize: "11px"
					                        }}
					                    >

					                        {String(h.hour)
					                            .padStart(2, "0")}

					                        :00

					                    </span>

					                </div>

					                {/* LABEL */}
					                <div
					                    style={{
					                        fontSize: "11px",
					                        opacity: 0.9,
					                        paddingLeft: "6px"
					                    }}
					                >

					                    {resolved.label}

					                </div>

					                {/* CAPACITY */}
					                <div
					                    style={{
					                        fontSize: "11px",
					                        opacity: 0.7,
					                        textAlign: "right",
					                        minWidth: "70px",
					                        paddingRight: "8px"
					                    }}
					                >

					                    {cap > 1 &&
					                        `${used}/${cap} • ${pct}%`}

					                </div>

									{/* BOOKING STATUS PILL */}
									<div
									    style={{
									        minWidth: "90px",
									        textAlign: "center"
									    }}
									>
									    {bookingLabel && (
									        <div
									            style={{
									                background: bookingColour,
									                color: "#fff",
									                borderRadius: "999px",
									                padding: "2px 8px",
									                fontSize: "10px",
									                display: "inline-block",
									                letterSpacing: "0.3px",
													width:'60px',
													marginLeft:'10px'
									            }}
									        >
									            {bookingLabel}
									        </div>
									    )}
									</div>

					            </div>

					        );

					    })}
						
		        </div>

		    );
	}